/* Component in the Shot component to display 
   the image for each Shot */
import React, { useEffect, useState } from 'react'
import Card from "react-bootstrap/Card"
import { useHistory } from "react-router-dom"
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Scene.module.css";
import { Image } from 'react-bootstrap';
import { useSetImageContext } from '../../../contexts/ImageContext';

const ShotImage = ({ image }) => {
    const [isImage, setIsImage] = useState(null);
    const setImage = useSetImageContext();
    const history = useHistory()

    useEffect(() => {
        const checkContentType = async () => {
            if (!image) return;

            try {
                const response = await fetch(image, { method: "HEAD" });
                const contentType = response.headers.get("Content-Type");

                if (contentType && contentType.startsWith("image/")) {
                    setIsImage(true);
                } else {
                    setIsImage(false);
                }
            } catch (err) {
                console.error("Failed to fetch content type:", err);
                setIsImage(null);
            }
        };

        checkContentType();
    }, [image]);

    const handleClickFull1 = () => {
    setImage(image); 
    history.push(`/${localStorage.getItem("projectSlug")}/fullshot`);
  };

    return (
        <div className={`${styles.InfoBack} mt-1 mb-3 pt-3`}>
            <Row>
                <Col className="text-center pt-1 pb-3">
                {/* desktop */}
                <Card className="shadow-sm h-100 mx-3 mx-md-5 d-none d-md-block">
                <Card.Body className={`text-center px-md-5 `}  >
                    {image ? (
                        isImage === null ? (
                            <p>Loading preview...</p>
                        ) : isImage ? (
                            <figure className="m-0 p-0 text-center">
                            <Card.Img
                            src={image} 
                            alt="shot" 
                            // height="300" 
                            style={{
                            maxHeight: "300px",
                            objectFit: "contain",
                            borderRadius: "8px",
                        }}
                            />
                           </figure>
                        ) : (
                            <iframe
                                src={image}
                                allow="fullscreen"
                                width="50%"
                                height="350"
                                title="file-preview"
                                style={{ border: "none", borderRadius: 8 }}
                            />
                        )
                    ) : (
                        <p>No image or file yet</p>
                    )}
                    </Card.Body>
                    {image ? (<Card.Body>
                    <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                        onClick={() => handleClickFull1() }>FULLSIZE</p> 
                    </Card.Body>) : ("") }
                </Card>
                {/*  mobile */}
                <Card className="shadow-sm h-100 d-block d-md-none">
                <Card.Body className={`text-center px-md-5 `}  >
                    {image ? (
                        isImage === null ? (
                            <p>Loading preview...</p>
                        ) : isImage ? (
                            <figure className="m-0 p-0 text-center">
                            <Card.Img
                            src={image} 
                            alt="shot" 
                            // height="300" 
                            style={{
                            maxHeight: "300px",
                            objectFit: "contain",
                            borderRadius: "8px",
                        }}
                            />
                           </figure>
                        ) : (
                            <iframe
                                src={image}
                                allow="fullscreen"
                                width="100%"
                                height="200"
                                title="file-preview"
                                style={{ border: "none", borderRadius: 8 }}
                            />
                        )
                    ) : (
                        <p>No image or file yet</p>
                    )}
                    </Card.Body>
                    <Card.Body>
                    <p className={`text-center mb-0 pb-0 float-right ${styles.FullsizeText }`}
                        onClick={() => handleClickFull1() }>FULLSIZE</p> 
                    </Card.Body>
                </Card>
                </Col>
            </Row>
        </div>
    )
}

export default ShotImage
